import APSegmentedControl from './APSegmentedControl';
import APSegmentedControlOption from './APSegmentedControlOption';

export {
  APSegmentedControl,
  APSegmentedControlOption
};

export default APSegmentedControl;
